module.exports = __webpack_public_path__ + "img/1.34a70540.png";